module.exports = __webpack_public_path__ + "static/media/icons.ed13eeb8.svg";